import { render, staticRenderFns } from "./ArrangeBaie.vue?vue&type=template&id=70073a7f&scoped=true&"
import script from "./ArrangeBaie.vue?vue&type=script&lang=js&"
export * from "./ArrangeBaie.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeBaie.vue?vue&type=style&index=0&id=70073a7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70073a7f",
  null
  
)

export default component.exports